import { useEffect } from "react";
import { useParams } from "react-router-dom";

const API_V1 = `${process.env.REACT_APP_BACKEND_URL}/api/v1`;

/**
 * /badge/:slug — tracks the click then redirects to the listing.
 * Used as the target for the embeddable LocalBest Verified Badge™.
 */
export default function BadgeRedirectPage() {
  const { slug } = useParams();

  useEffect(() => {
    if (!slug) return;
    const target = `/business/${slug}`;
    // Fire-and-forget tracking, then redirect immediately
    try {
      const url = `${API_V1}/badge/${encodeURIComponent(slug)}/click?source=website_badge`;
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url);
      } else {
        fetch(url, { method: "POST", keepalive: true }).catch(() => {});
      }
    } catch (_) { /* ignore */ }
    // Small timeout so the beacon has a tick to fire
    const t = setTimeout(() => { window.location.replace(target); }, 60);
    return () => clearTimeout(t);
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#0B1226] flex items-center justify-center text-white text-sm" data-testid="badge-redirect-page">
      Redirecting to LocalBest.ai…
    </div>
  );
}
